import React from 'react';
import { MessageSquare, Lightbulb, CheckCircle } from 'lucide-react';

const steps = [
  {
    number: 1,
    title: 'Describe',
    subtitle: "What's the situation?",
    description: '"Tell me about the tricky situation you\'re dealing with..."',
    icon: MessageSquare
  },
  {
    number: 2,
    title: 'Explore',
    subtitle: 'Think it through together',
    description: '"What\'s really going on here? What matters most?"',
    icon: Lightbulb
  },
  {
    number: 3,
    title: 'Clarify',
    subtitle: 'Walk away with a plan',
    description: '"Here\'s how you might approach this..."',
    icon: CheckCircle
  }
];

const HowItHelps = ({ series }) => {
  const accentColor = series?.accentColor || '#dc2626';

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-6 lg:px-12">
        <div className="text-center mb-14">
          <h2 className="text-3xl lg:text-4xl font-bold text-slate-900 mb-4">
            How it helps you think clearer
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            Not advice. Not therapy. Just structured thinking when you need it.
          </p>
        </div>

        <div className="max-w-5xl mx-auto">
          <div className="grid md:grid-cols-3 gap-8 relative">
            {/* Connecting line */}
            <div className="hidden md:block absolute top-16 left-[16%] right-[16%] h-0.5 bg-gradient-to-r from-slate-200 via-slate-300 to-slate-200" />
            
            {steps.map((step, index) => {
              const Icon = step.icon;
              return (
                <div key={step.number} className="relative text-center">
                  {/* Step number circle */}
                  <div 
                    className="w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-5 text-white font-bold text-lg relative z-10"
                    style={{ backgroundColor: accentColor }}
                  >
                    {step.number}
                  </div>
                  
                  {/* Icon */}
                  <div 
                    className="w-16 h-16 rounded-2xl flex items-center justify-center mx-auto mb-4"
                    style={{ backgroundColor: `${accentColor}10` }}
                  >
                    <Icon className="w-8 h-8" style={{ color: accentColor }} />
                  </div>
                  
                  {/* Content */}
                  <h3 className="text-xl font-bold text-slate-900 mb-1">{step.title}</h3>
                  <p className="text-slate-600 font-medium mb-3">{step.subtitle}</p>
                  <p className="text-sm text-slate-500 italic">{step.description}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItHelps;
